import { render, staticRenderFns } from "./prizeClaimDetails.vue?vue&type=template&id=2601db4d&scoped=true"
import script from "./prizeClaimDetails.vue?vue&type=script&lang=js"
export * from "./prizeClaimDetails.vue?vue&type=script&lang=js"
import style0 from "./prizeClaimDetails.vue?vue&type=style&index=0&id=2601db4d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2601db4d",
  null
  
)

export default component.exports